<div class="app-shell">
  <app-loader [style.display]="isLoading() ? 'block' : 'none'"></app-loader>

  <app-navbar [style.display]="showLayout() ? 'block' : 'none'"></app-navbar>

  <main [class.main-with-navbar]="showLayout()" class="main-content">
    <router-outlet></router-outlet>
  </main>
</div>
